/* @freightos/design-system variables | v5.13.2 | License: ISC */

module.exports = {
  "fdsPrimaryColor": "#2075bd",
  "fdsErrorColor": "#d8271e",
  "fdsBodyTextColor": "#53575f",
  "fdsBodyTextColorDisabled": "#8a8d8f",
  "fdsHeadingsTextColor": "#232537",
  "fdsComponentPrimaryColor": "#2075bd",
  "fdsComponentPrimaryColorHover": "var(--primary-color-40, #125c9b)",
  "fdsComponentPrimaryColorClick": "var(--primary-color-50, #05387d)",
  "fdsComponentPrimaryColorError": "#d8271e",
  "fdsComponentPrimaryColorDisabled": "#8a8d8f",
  "fdsComponentSecondaryColor": "#c6c7c7",
  "fdsComponentSecondaryColorDisabled": "#e5e6e6",
  "fdsComponentTertiaryColorHover": "var(--primary-color-10, #e1f5f9)",
  "fdsComponentTertiaryColorClick": "var(--primary-color-20, #ace8f0)",
  "fdsComponentDangerColorHover": "#9b0f1f",
  "fdsComponentDangerColorClick": "#670521",
  "fdsComponentInvertColor": "#ffffff",
  "fdsComponentBackgroundColor": "#ffffff",
  "fdsComponentBackgroundColorDisabled": "#f6f6f6",
  "fdsComponentColorPositive": "#47a96e",
  "fdsComponentColorAttention": "#edaf07",
  "fdsComponentColorNegative": "#d8271e",
  "fdsComponentBackgroundColorPositive": "#eafdea",
  "fdsComponentBackgroundColorAttention": "#fef6cc",
  "fdsComponentBackgroundColorNegative": "#ffede1",
  "fdsComponentBackgroundColorInformation": "#e1f5f9",
  "fdsComponentTextColorPlaceholder": "#afb2b2",
  "fdsInputBorderColorDefault": "#c6c7c7",
  "fdsInputBorderColorErrorFocus": "#fbbea4",
  "fdsButtonColorDisabled": "var(--disabled-color, #b0cee8)",
  "fdsTooltipBackgroundColor": "#3b3f4b",
  "fdsChipSelectBackgroundColor": "#ace8f0",
  "fdsChipSelectColorPrimary": "#125c9b",
  "fdsChipBackgroundColorSecondary": "#e1f5f9",
  "fdsChipBackgroundColorEmphasis": "#e7d8fc",
  "fdsChipColorPrimaryEmphasis": "#715397",
  "fdsChipBackgroundColorNegative": "#fbbea4",
  "fdsChipBackgroundColorNegativeSecondary": "#ffede1",
  "fdsChipColorNegativeSecondary": "#d8271e",
  "fdsChipColorPrimaryNegative": "#9b0f1f",
  "fdsChipBackgroundColorPositive": "#bdf6c2",
  "fdsChipColorPrimaryPositive": "#237957",
  "fdsChipBackgroundColorAttention": "#fdea9a",
  "fdsChipColorPrimaryAttention": "#9c6b02",
  "fdsChipBackgroundColorNeutral": "#e5e6e6",
  "fdsChipColorPrimaryNeutral": "#53575f",
  "primaryColor10Token": "var(--primary-color-10, #e1f5f9)",
  "primaryColor20Token": "var(--primary-color-20, #ace8f0)",
  "primaryColorToken": "var(--primary-color, #2075bd)",
  "primaryColor40Token": "var(--primary-color-40, #125c9b)",
  "primaryColor50Token": "var(--primary-color-50, #05387d)",
  "disabledColorToken": "var(--disabled-color, #b0cee8)",
  "fdsColorPrimaryBlue10": "#e1f5f9",
  "fdsColorPrimaryBlue20": "#ace8f0",
  "fdsColorPrimaryBlue": "#2075bd",
  "fdsColorPrimaryBlue40": "#125c9b",
  "fdsColorPrimaryBlue50": "#05387d",
  "fdsColorSemanticRed10": "#ffede1",
  "fdsColorSemanticRed20": "#fbbea4",
  "fdsColorSemanticRed": "#d8271e",
  "fdsColorSemanticRed40": "#9b0f1f",
  "fdsColorSemanticRed50": "#670521",
  "fdsColorSemanticYellow10": "#fef6cc",
  "fdsColorSemanticYellow20": "#fdea9a",
  "fdsColorSemanticYellow": "#edaf07",
  "fdsColorSemanticYellow30": "#dc9500",
  "fdsColorSemanticYellow40": "#9c6b02",
  "fdsColorSemanticYellow50": "#714601",
  "fdsColorSemanticGreen10": "#eafdea",
  "fdsColorSemanticGreen20": "#bdf6c2",
  "fdsColorSemanticGreen": "#47a96e",
  "fdsColorSemanticGreen40": "#237957",
  "fdsColorSemanticGreen50": "#0d5143",
  "fdsColorPrimaryWhite": "#ffffff",
  "fdsColorPrimaryGray05": "#fbfbfb",
  "fdsColorPrimaryGray10": "#f6f6f6",
  "fdsColorPrimaryGray20": "#e5e6e6",
  "fdsColorPrimaryGray30": "#c6c7c7",
  "fdsColorPrimaryGray40": "#afb2b2",
  "fdsColorPrimaryGray50": "#999c9d",
  "fdsColorPrimaryGray60": "#8a8d8f",
  "fdsColorPrimaryGray70": "#6a6f73",
  "fdsColorPrimaryGray80": "#53575f",
  "fdsColorPrimaryGray90": "#3b3f4b",
  "fdsColorPrimaryGray": "#232537",
  "fdsColorAccentPurple10": "#e7d8fc",
  "fdsColorAccentPurple": "#715397",
  "fdsColorTransparent": "transparent",
  "fdsColorDisabled": "#b0cee8",
  "fdsSizeXs": "12px",
  "fdsSizeSm": "16px",
  "fdsSizeMd": "20px",
  "fdsSizeLg": "24px",
  "fdsSizeXl": "32px",
  "fdsSizeXxl": "40px",
  "fdsSizeXxxl": "48px",
  "fdsSizeBig": "64px",
  "fdsSizeHuge": "96px",
  "fdsBorderRadiusSm": "2px",
  "fdsBorderRadiusMd": "4px",
  "fdsBorderRadiusLg": "8px",
  "fdsBorderRadiusXl": "80px",
  "fdsBorderWidthSm": "1px",
  "fdsBorderWidthMd": "2px",
  "fdsBorderWidthLg": "4px",
  "fdsBorderWidthXl": "8px",
  "fdsComponentMinWidth": "120px",
  "fdsCheckboxSize": "16px",
  "fdsBreakpointSizeXs": "480px",
  "fdsBreakpointSizeSm": "576px",
  "fdsBreakpointSizeMd": "768px",
  "fdsBreakpointSizeLg": "992px",
  "fdsBreakpointSizeXl": "1200px",
  "fdsBreakpointSizeXxl": "1600px",
  "fdsBreakpointXs": "(max-width:480px)",
  "fdsBreakpointSm": "(max-width:576px)",
  "fdsBreakpointMd": "(min-width:768px)",
  "fdsBreakpointLg": "(max-width:992px)",
  "fdsBreakpointXl": "(max-width:1200px)",
  "fdsBreakpointXxl": "(max-width:1600px)",
  "fdsBodyFontFamily": "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
  "fdsHeadingsFontFamily": "Open Sans",
  "fdsCodeFontFamily": "Courier New",
  "fdsBodyLineHeight": "1.5",
  "fdsTitleLineHeight": "1.25",
  "fdsFontSizeSm": "12px",
  "fdsFontSizeBase": "14px",
  "fdsH6FontSize": "16px",
  "fdsH5FontSize": "18px",
  "fdsH4FontSize": "20px",
  "fdsH3FontSize": "24px",
  "fdsH2FontSize": "32px",
  "fdsH1FontSize": "40px",
  "fdsFontWeightRegular": "400",
  "fdsFontWeightSemibold": "600",
  "fdsFontWeightBold": "700",
  "fdsBoxShadowSm": "0 0 10px 0 rgba(35, 37, 55, 0.12)",
  "fdsBoxShadowMd": "0 0 15px 0 rgba(35, 37, 55, 0.12)",
  "fdsBoxShadowLg": "0 0 48px 0 rgba(35, 37, 55, 0.12)",
  "fdsComponentBoxShadowFocus": "0 0 0 2px #ace8f0",
  "fdsComponentBoxShadowToken": "0 0 0 2px var(--primary-color-20)",
  "fdsComponentBoxShadowErrorFocus": "0 0 0 2px #fbbea4",
  "fdsComponentSpacingXs": "4px",
  "fdsComponentSpacingXxs": "2px",
  "fdsComponentSpacingSm": "8px",
  "fdsComponentSpacingMd": "12px",
  "fdsComponentSpacingLg": "16px",
  "fdsComponentSpacingXl": "24px",
  "fdsComponentSpacingXxl": "32px",
  "fdsComponentSpacingXxxl": "64px"
};